import React from "react";
import { Button } from "@/components/ui/button";

interface ReportFailureStateProps {
  onRetry: () => void;
}

/**
 * Distinct failure affordance for a failed report run. Deliberately separate
 * from the empty-month placeholder so a user can tell "couldn't load" apart
 * from "no data for this month". The error *message* is owned by the global
 * axios interceptor (toast); this only offers a retry.
 */
const ReportFailureState: React.FC<ReportFailureStateProps> = ({ onRetry }) => (
  <div className="rounded-md border border-dashed border-red-300 p-10 text-center dark:border-red-500/40">
    <p className="text-sm text-gray-600 dark:text-slate-300">
      We couldn&apos;t load the report. Please try again.
    </p>
    <Button className="mt-4" onClick={onRetry} variant="outline">
      Try again
    </Button>
  </div>
);

export default ReportFailureState;
